// @generated by TypeGen from LogbookModel/Log/LogMetadata.swift - DO NOT EDIT

import type { IGeneratorRunState } from "../Generator/GeneratorRunStatus"
import type { ILogLighting } from "../Lighting"
import type { IAlertStatusType } from "../Status/AlertStatus"
import type { IEngineStatus } from "../Status/EngineStatus"
import type { IShipStatus } from "../Status/ShipStatus"

export interface ILogAlertEntry {
  alert: IAlertStatusType;
  action: ILogAlertAction;
  by?: number;
  skipper?: number;
  onWatch: number[];
}

export interface ILogChange {
  action: ILogChangeAction;
  type: ILogChangeType;
  id: number;
}

export interface ILogDataRecordEntry {
  generator?: ILogDataRecordGeneratorEntry[];
}

export interface ILogDataRecordGeneratorEntry {
  number: number;
  status: IGeneratorRunState;
}

export interface ILogEngineMissingEntry {
  sinceLogId: number;
  reason: IEngineMissingReason;
}

export interface ILogMetadata {
  type: ILogAutoType;
  engineName?: string;
  engineNumber?: number;
  engineStatus?: ILogOnOff;
  engineRunState?: IEngineStatus;
  intervalDuration?: number;
  navigationStatus?: ILogOnOff;
  nmeaConnection?: ILogOnOff;
  nmeaConnectionUserInitiated?: boolean;
  shipStatus?: IShipStatus;
  stopLocation?: string;
  stopType?: ILogStopType;
  speedChange?: ILogSpeedChange;
  lighting?: ILogLighting;
  propulsion?: ILogOnOff;
  engineMissing?: ILogEngineMissingEntry;
  dataRecord?: ILogDataRecordEntry;
  alert?: ILogAlertEntry;
  nmeaAuto: boolean;
  nmeaAutoInterval?: number;
  nmeaAutoPending?: boolean;
  provisionalKey?: string;
  nmeaConnectionStartStop?: boolean;
  nmeaCourseChangeDuration?: number;
  nmeaCourseChangeNew?: number;
  nmeaCourseChangePrevious?: number;
  nmeaCourseChangePhase?: ILogCourseChangePhase;
  nmeaSpeedChange?: number;
  nmeaSpeedStartStop?: boolean;
  changes?: ILogChange[];
  auditLogEditIds?: number[];
  nmeaFields?: string[];
}

export enum IEngineMissingReason {
  castOff = "castOff",
  anchorUp = "anchorUp",
  motorVessel = "motorVessel",
}

export enum ILogAlertAction {
  triggered = "triggered",
  escalated = "escalated",
  snoozed = "snoozed",
  acknowledged = "acknowledged",
  cleared = "cleared",
  resolved = "resolved",
}

export enum ILogAutoType {
  none = "none",
  courseChange = "courseChange",
  engine = "engine",
  engineRunState = "engineRunState",
  interval = "interval",
  monitor = "monitor",
  navigationStatus = "navigationStatus",
  nmeaConnection = "nmeaConnection",
  shipStatus = "shipStatus",
  stop = "stop",
  speedChange = "speedChange",
  lighting = "lighting",
  propulsion = "propulsion",
  engineMissing = "engineMissing",
  dataRecord = "dataRecord",
  alert = "alert",
}

export enum ILogChangeAction {
  add = "add",
  remove = "remove",
}

export enum ILogChangeType {
  crew = "crew",
  passengers = "passengers",
  skipper = "skipper",
}

export enum ILogCourseChangePhase {
  active = "active",
  begin = "begin",
  end = "end",
}

export enum ILogOnOff {
  on = "on",
  off = "off",
  missing = "missing",
}

export enum ILogSpeedChange {
  start = "start",
  stop = "stop",
}

export enum ILogStopType {
  endOfDay = "endOfDay",
  stopover = "stopover",
}
